import { AxiosInstance, AxiosPromise } from 'axios';
import {
  TerminalServicesEndpoint,
  TerminalRequest,
  TerminalResponse,
  TerminalsRequest,
  TerminalsResponse,
  UpdateTerminalRequest,
  CreateTerminalRequest,
  CreateTerminalResponse,
  MergeTerminalsRequest,
} from './TerminalServices.types';

import { TerminalContactServices, TerminalContactEndpoints } from './services';

export class TerminalServices implements TerminalServicesEndpoint {
  instance: AxiosInstance;
  contacts: TerminalContactEndpoints;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.contacts = new TerminalContactServices(instance);
  }

  search(request: TerminalsRequest): AxiosPromise<TerminalsResponse> {
    return this.instance.get(`/terminals`, { params: request.queryParams });
  }

  create(request: CreateTerminalRequest) {
    return this.instance.post<CreateTerminalResponse>(`/terminals`, request.body);
  }

  getByGuid(request: TerminalRequest): AxiosPromise<TerminalResponse> {
    return this.instance.get(`/terminals/${request.routeParams.id}`);
  }

  update(request: UpdateTerminalRequest): AxiosPromise<TerminalResponse> {
    return this.instance.put(`/terminals/${request.routeParams.id}`, request.body);
  }

  delete(request: TerminalRequest): AxiosPromise<void> {
    return this.instance.delete(`/terminals/${request.routeParams.id}`);
  }

  merge(request: MergeTerminalsRequest) {
    return this.instance.post<void>(`/terminals/${request.routeParams.guid}/merge`, request.body);
  }
}
